import React from "react";

interface CustomToggleProps {
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: string;
  className?: string;
}

export const CustomToggle = React.forwardRef<HTMLButtonElement, CustomToggleProps>(
  ({ children, onClick, variant, className }, ref) => (
    <button
      ref={ref}
      className={`btn btn-${variant} ${className}`}
      onClick={(e) => {
        e.preventDefault();
        onClick?.(e);
      }}
    >
      {children}
    </button>
  )
);

CustomToggle.displayName = 'CustomToggle';